import React from 'react';
import {
    Popover,
    PopoverTrigger,
    IconButton,
    PopoverBody,
    PopoverHeader,
    FormLabel,
    FormControl,
    Switch,
    PopoverContent,
    IconButtonProps,
} from '@chakra-ui/react';
import { UpDownIcon } from '@chakra-ui/icons';

const InactiveOrganisationPopover = ({
    showInactive,
    setShowInactive,
    ...props
}: {
    showInactive: boolean;
    setShowInactive: (inactive: boolean) => void;
} & Omit<IconButtonProps, 'aria-label'>) => (
    <Popover>
        <PopoverTrigger>
            <IconButton
                size="sm"
                icon={<UpDownIcon />}
                aria-label="Show inactive organisations"
                variant="ghost"
                {...props}
            />
        </PopoverTrigger>
        <PopoverContent>
            <PopoverHeader fontWeight="bold">Show Inactive Organisations</PopoverHeader>
            <PopoverBody p={4}>
                Inactive organisations are not shown in the organisation dropdown unless show all organisations is
                enabled below.
                <FormControl
                    flexDir="row"
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    mt={4}
                    ml="auto"
                >
                    <FormLabel>Show All Organisations:</FormLabel>
                    <Switch isChecked={showInactive} onChange={(ev) => setShowInactive(ev.target.checked)} size="md" />
                </FormControl>
            </PopoverBody>
        </PopoverContent>
    </Popover>
);

export default InactiveOrganisationPopover;
